import { IFlightOnlineBookingList } from "libs/data-access/types";
import { IAffiliateSignUpForm, IUser } from "./types";

export const BASE64_INITIALS = "data:image/jpeg;base64,";

export const initialUser: IUser = {
  firstName: "",
  lastName: "",
  emailId: "",
  createdDate: "",
  lastModifiedDate: "",
  createdBy: "",
  lastModifiedBy: "",

};


export const initialFormValues: IAffiliateSignUpForm = {
  companyName: "",
  website: "",
  firstAddress: "",
  secondAddress: "",
  countryId: "",
  stateId: null,
  city: "",
  pinCode: "",
  companyType: "",
  panNumber: "",
  tdsExemptionNumber: "",
  lookToBookRatioSearch: null,
  lookToBookRatioBook: null,
  tdsExemptionLimit: null,
  tdsExemptionRate: null,
  tdsExemptionCode: null,
  xlCode: "",
  isLogoAdvice: false,
  isCorporate: false,
  isSupplierPromoCode: false,
  gstNumber: "",
  email: "",
  mobileNumber: null,
  aadhaarCardId: null,
  panCardId: null,
  gstId: null,
  drivingLicenseId: null,
  companyLogoId: null,
  title: "",
  contactNumber: "",
  firstName: "",
  lastName: "",
  pmlAffiliate: false,
  aadhaarNumber: null,
  companyRegistrationId: 0
};

export const initialFlightTicket: IFlightOnlineBookingList = {
  uuid: "",
  id: 0,
  traceId: "",
  createdDate: "",
  contactNumber: null,
  email: null,
  invoiceNo: null,
  refundNo: null,
  bookingResponses: [],
  paymentOrder: {
    id: 0,
    orderId: "",
    paymentSessionId: "",
    travelServiceCategory: "",
    naviatorOrderDetail: {
      indigoBasePrice: null,
      indigoTaxPrice: 0,
      indigoSsrPrice: 0,
      indigoSeatPrice: 0,
    },
    galelioFlightOrderDetail: {
      flightBasePrice: 0,
      flightTaxPrice: 0,
    },
    akbarOrderDetail: {
      akbarBasePrice: 0,
      akbarTaxPrice: 0,
      akbarSsrPrice: 0,
      akbarSeatPrice: 0,
    },
    adminOtherCharge: 0,
    adminTotalGst: 0,
    adminBaseCharge: 0,
    adminServiceCharge: 0,
    adminBookingCharge: 0,
    paymentCharge: 0,
    discount: 0,
    paymentStatus: "",
    affiliateOtherCharges: 0,
    affiliateTotalGst: 0,
    affiliateBaseCharge: 0,
    affiliateServiceCharge: 0,
    affiliateBookingCharge: 0,
    commissionBaseFare: 0,
    commissionSurcharge: 0,
    commissionOtherTaxes: 0,
    commissionIncentive: 0,
    commissionPlbBaseFare: 0,
    commissionPlbYQ: 0,
    commissionPlbYR: 0,
    commissionPlbBaseFareYQ: 0,
    commissionPlbBaseFareYR: 0,
    commissionCashback: 0,
    commissionTds: 0,
  },
  bookedBy: "AFFILIATE",
  userResponse: {
    id: 0,
    name: {
      firstName: "",
      middleName: "",
      lastName: "",
    },
    emailId: "",
    phoneNumber: "",
    address: "",
    city: "",
    pinCode: "",
    companyName: "",
  }
};